<template>
  <section class="service-cards">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title scroll-animate fade-up" data-delay="0">
          {{ $i18n.t('nav.download') }}
        </h2>
        <!-- <p class="section-subtitle scroll-animate fade-up" data-delay="100">{{ $i18n.t('service.subtitle') }}</p> -->
      </div>

      <div class="cards-grid">
        <div
          v-for="(card, index) in cards"
          :key="index"
          class="service-card card-hover scroll-animate zoom-out"
          :data-delay="(index + 1) * 150"
        >
          <div class="card-icon">
            <component :is="card.icon" />
          </div>
          <h3 class="card-title">{{ $i18n.t(card.titleKey) }}</h3>
          <p class="card-desc">{{ $i18n.t(card.descKey) }}</p>
          <router-link :to="card.link" class="card-link link-underline">
            了解更多
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { h } from 'vue'
import { useScrollAnimation } from '../composables/useScrollAnimation'

useScrollAnimation()

// SVG图标组件
const DownloadIcon = () => h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '40', height: '40', viewBox: '0 0 24 24',
  fill: 'none', stroke: 'currentColor', 'stroke-width': '1.5', 'stroke-linecap': 'round', 'stroke-linejoin': 'round'
}, [
  h('path', { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' }),
  h('polyline', { points: '7 10 12 15 17 10' }),
  h('line', { x1: '12', y1: '15', x2: '12', y2: '3' })
])

// const WalletIcon = () => h('svg', {
//   xmlns: 'http://www.w3.org/2000/svg',
//   width: '40', height: '40', viewBox: '0 0 24 24',
//   fill: 'none', stroke: 'currentColor', 'stroke-width': '1.5', 'stroke-linecap': 'round', 'stroke-linejoin': 'round'
// }, [
//   h('rect', { x: '1', y: '4', width: '22', height: '16', rx: '2', ry: '2' }),
//   h('line', { x1: '1', y1: '10', x2: '23', y2: '10' })
// ])

// const UserIcon = () => h('svg', {
//   xmlns: 'http://www.w3.org/2000/svg',
//   width: '40', height: '40', viewBox: '0 0 24 24',
//   fill: 'none', stroke: 'currentColor', 'stroke-width': '1.5', 'stroke-linecap': 'round', 'stroke-linejoin': 'round'
// }, [
//   h('path', { d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2' }),
//   h('circle', { cx: '12', cy: '7', r: '4' })
// ])

const cards = [
  { icon: DownloadIcon, titleKey: 'service.download.title', descKey: 'service.download.desc', link: '/download' },
  // { icon: WalletIcon, titleKey: 'service.deposit.title', descKey: 'service.deposit.desc', link: '/contact' },
  // { icon: UserIcon, titleKey: 'service.account.title', descKey: 'service.account.desc', link: '/contact' },
]
</script>

<style scoped>
.service-cards {
 background-color: #fff;
 padding: 6.25rem 0;
 position: relative;
}

.service-cards::before {
 content: ‘’;
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 height: 1px;
 background: linear-gradient(
 90deg,
 transparent,
 rgba(71, 121, 181, 0.3),
 transparent
 );
}

.container {
  max-width: 75rem;
  margin: 0 auto;
  padding: 0 2.5rem;
}

.section-header {
  text-align: center;
  margin-bottom: 3.75rem;
}

.section-title {
 font-size: 3rem;
 font-weight: 700;
 color: #333;
 margin-bottom: 1.2rem;
}

.section-subtitle {
 font-size: 1.13rem;
 color: #a0aec0;
}

.cards-grid {
 display: grid;
 /* grid-template-columns: repeat(3, 1fr); */
 grid-template-columns: 1fr;
 gap: 1.88rem;
}

.service-card {
 background: linear-gradient(180deg, #cce6ff 0%, #fff 100%);
 box-shadow: 0px 0.06rem 0.21rem 0px rgba(0, 0, 0, 0.05);
 border-radius: 0.75rem;
 padding: 2.5rem 1.88rem;
 text-align: center;
 transition: all 0.3s ease;
 /* box-shadow: 0 0.13rem 0.5rem rgba(0, 0, 0, 0.04); */
}

.service-card:hover {
 border-color: rgba(71, 121, 181, 0.3);
 /* background: #ffffff; */
 box-shadow: 0 0.5rem 1.5rem rgba(71, 121, 181, 0.12);
 transform: translateY(-0.25rem);
}

.card-icon {
  width: 5rem;
  height: 5rem;
  margin: 0 auto 1.56rem;
  background: linear-gradient(135deg, rgba(71, 121, 181, 0.1), rgba(71, 121, 181, 0.03));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4779B5;
  transition: all 0.3s ease;
}

.service-card:hover .card-icon {
  background: linear-gradient(135deg, rgba(71, 121, 181, 0.18), rgba(71, 121, 181, 0.06));
  transform: scale(1.08);
}

.card-title {
  font-size: 1.38rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 1.2rem;
}

.card-desc {
  font-size: 1.2rem;
  color: #64748b;
  line-height: 1.7;
  margin-bottom: 1.56rem;
}

.card-link {
  display: inline-flex;
  align-items: center;
  gap: 0.38rem;
  color: #4779B5;
  font-size: 0.88rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
}

.card-link:hover {
  gap: 0.63rem;
  color: #3A6699;
}

@media (max-width: 62rem) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .service-card:last-child {
    grid-column: span 2;
    max-width: 25rem;
    margin: 0 auto;
    width: 100%;
  }
}

@media (max-width: 48rem) {
  .service-cards {
    padding: 3.75rem 0;
  }

  .container {
    padding: 0 1.25rem;
  }

  .section-title {
    font-size: 1.75rem;
  }

  .section-subtitle {
    font-size: 1.2rem;
  }

  .cards-grid {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }

  .service-card:last-child {
    grid-column: span 1;
    max-width: none;
  }

  .service-card {
    padding: 1.88rem 1.25rem;
  }

  .card-icon {
    width: 4.38rem;
    height: 4.38rem;
  }

  .card-title {
    font-size: 1.25rem;
  }
}
</style>
